import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeftAndRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.496 13a.999.999 0 0 0 .71-.29l2.498-2.5a1.001 1.001 0 0 0 0-1.42l-2.498-2.5a1.003 1.003 0 1 0-1.42 1.42l.795.79h-5.582a1 1 0 0 0 0 2h5.582l-.794.79a1.001 1.001 0 0 0 .71 1.71Zm-8.99-2.004a1 1 0 0 0-.71.29l-2.5 2.5a1 1 0 0 0 0 1.42l2.5 2.5a1.004 1.004 0 1 0 1.42-1.42l-.795-.79h5.585a1 1 0 1 0 0-2H7.42l.795-.79a1 1 0 0 0-.71-1.71Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowLeftAndRight;
